import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export const useStore = defineStore('store', {
  state: () => ({}),
  actions: {
    // 分页查询店铺
    async getStorePage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/store/page',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 店铺详情
    async getStoreInfo(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/store/info/${id}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增店铺
    async createStore(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/store/create',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 编辑店铺
    async updateStore(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/store/update',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除店铺
    async deleteStore(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/store/del/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
